import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';
import Loading from '../Loading/Loading';
import { AdminContext } from '../../types';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  // Assuming the context provides these values
  const { isAdmin } = useOutletContext<AdminContext>();

  if (isAdmin === null) {
    return <Loading />;
  }

  return isAdmin ? <>{children}</> : <Navigate to="/dashboard" />;
};

export default AdminRoute;
